var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from '../baseService';
export class RegionService extends BaseService {
    constructor(props) {
        super(props);
    }
    list(options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('regions.list', {}, options);
            return res;
        });
    }
    listAvailable(options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('regions.list_available', {}, options);
            return res;
        });
    }
    availableLiveqServicesByRegion(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.api.fetchLoggedV3('liveq_services.list_for_region', Object.assign(Object.assign({}, params), { expand: { "liveq_service": ["liveq_program_id"] } }), options);
            return res;
        });
    }
}
